<template>
  <div class="hello">
    <div class="refund_detail">
      <div class="detail_refund_top">
       <div class="refundLeft">
         <div class="left">
           <span>{{detail.statusText}}</span>
         </div>
           <div class="message" v-if="detail.status == 12">
             <span>驳回原因: {{detail.message}}</span>
           </div>
       </div>

          <div class="refundBtn" @click="refundE" v-if="detail.status == 12">
            <span>退款</span>
          </div>
      </div>
      <div class="tab">
        <span>商品清单和结算信息</span>
      </div>
      <div class="detail_refund_goods">
        <div class="top_refund">
          <div class="title_refund_sn">
            <span>订单号：{{detail.order_goods.ordersn}}</span>
          </div>
          <div class="title_refund_sn">
            <span>提交时间：{{detail.create_time}}</span>
          </div>
        </div>
        <div class="refund_goods">
          <div class="refund_goods_list">
            <div class="refund_goods_pic">
              <img :src="detail.order_goods.spec_pic" alt="">

            </div>
            <div class="goods_title_refund">
              <p style="margin-top: 39px;">{{detail.order_goods.goods_title}}</p>
              <p class="refund_p">套餐：{{detail.order_goods.spec_name}}</p>
            </div>
            <div class="goods_numb_refund"></div>
            <div class="goods_numb_refund"></div>
            <div class="goods_numb_refund"></div>
            <div class="goods_numb_refund"></div>
            <div class="goods_numb_refund">
              <span>{{detail.order_goods.goods_num}}个</span>
            </div>
            <div class="refund_price">
              <span>{{detail.order_goods.spec_price}}</span>
            </div>
          </div>
          <div class="refund_bottom">
            <div class="right_refund">
              <p style="margin-top: 19px;">商品总金额：￥{{(detail.order_goods.goods_num * parseFloat(detail.order_goods.spec_price).toFixed(2))}}</p>
              <p style="margin-top: 5px;">运费：￥{{detail.fee_price}}</p>
              <p style="margin-top: 5px;">总计：<span style="color: #F33131;">￥{{detail.price}}</span></p>
            </div>
          </div>
        </div>

      </div>

     <div class="order_message">
       <div class="message_refund">
          <span>订单基本信息</span>
       </div>
       <div class="msg">
          <p>退款原因：{{detail.cause}}</p>
          <p v-if="detail.refund_type == '已收货退款'">退款金额: ¥{{(parseFloat(detail.price) - parseFloat(detail.fee_price)).toFixed(2)}}</p>
           <p v-else>退款金额: ¥{{detail.price}}</p>
           <p>用户留言:{{detail.content}}</p>
          <p>申请时间: {{detail.create_time}}</p>
       </div>
     </div>
    </div>
    <refund :refundShow="refundShow" @closeEvent="closeEvent()" :orderType="detail.refund_type"   :goodslist="goodsli"></refund>
  </div>
</template>

<script>
  import refund from '../components/reRefund.vue'
  export default {
  components:{
    refund
  },
    data() {
      return {
        detail:{},
        refundShow:false,
        goodsli:[]
      }
    },
    created() {
      this.$fetch('refund/detail',{id:this.$route.query.id}).then(res=>{
        this.detail = res.data;
      })
    },
    methods: {
      closeEvent(data){

        this.refundShow = data;
      },
      refundE(){
        var arr = [];
        arr.push(this.detail.order_goods);
        this.goodsli = arr;
        localStorage.setItem('order_goods',JSON.stringify(this.detail.order_goods));
        this.refundShow = true;
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/refunddetail.css");
</style>



// WEBPACK FOOTER //
// src/pages/refunddetail.vue